<template>
  <div>
    <h1>500</h1>
  </div>
</template>

<script>
export default {
  created: function() {
    // Redirect outside the app using plain old javascript
    // window.location.href = "/static/404-not-found.html";
  }
}
</script>



// WEBPACK FOOTER //
// 500.vue?8cef7062